
import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody, TabPanel, TextControl, SelectControl } from '@wordpress/components';
import { produce } from 'immer';

// Settings Components
import { ColorControl, Typography } from '../../bpl-tools/Components';
import { tabController } from '../../bpl-tools/utils/functions';
import { contentOpt, generalStyleTabs } from './utils/options';

const Settings = ({ attributes, setAttributes }) => {
	const { content, contentType, contentTypo, contentColor } = attributes;

	return <>
		<InspectorControls>
			<TabPanel className='bPlTabPanel' activeClass='activeTab' tabs={generalStyleTabs} onSelect={tabController}>{tab => <>
				{'general' === tab.name && <>

					<PanelBody className='bPlPanelBody' title={__('Input Content', 'mail-and-content-protect')} >

						<SelectControl label={__('Select Content Type', 'mail-and-content-protect')} value={contentType} options={contentOpt} onChange={(val) => { setAttributes({ contentType: val }) }} />
						{(() => {
							switch (contentType) {
								case "text":
									return <TextControl label={__('Content', 'mail-and-content-protect')} value={content?.text} onChange={(val) => { setAttributes({ content: { ...content, text: val } }); }} />;
								case "phone":
									return <TextControl label={__('Phone Number', 'mail-and-content-protect')} value={content?.phone} onChange={(val) => { setAttributes({ content: { ...content, phone: val } }); }} />;
								case "email":
									return <TextControl label={__('Email', 'mail-and-content-protect')} value={content?.email} onChange={(val) => { setAttributes({ content: { ...content, email: val } }); }} />;
								case "url":
									return <TextControl label={__('Url', 'mail-and-content-protect')} value={content?.url} onChange={(val) => { setAttributes({ content: { ...content, url: val } }); }} />;
								default:
									return null;
							}
						})()}

					</PanelBody>
				</>}


				{'style' === tab.name && <>
					<PanelBody className='bPlPanelBody' title={__('Custom Style', 'mail-and-content-protect')}>
						<Typography className='' label={__('Typography', 'mail-and-content-protect')} value={contentTypo} onChange={(val) => { setAttributes({ contentTypo: val }) }} produce={produce} />

						<ColorControl label={__('Color', 'mail-and-content-protect')} className='' value={contentColor} onChange={(val) => { setAttributes({ contentColor: val }) }} />
					</PanelBody>
				</>}
			</>}</TabPanel>
		</InspectorControls>

	</>;
};
export default Settings;